'use strict';
const angular = require('angular');

export class calendarWidgetComponent {

  constructor($uibModal, CalendarEventService, Auth) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.CalendarEventService = CalendarEventService;
    this.Auth = Auth;

    this.eventSources =  [];
    var eventSource = {
      events: []
    };

    this.eventSources.push(eventSource);

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        editable: true,
        defaultView: 'listWeek',
        header: {
          left: '',
          center: '',
          right: ''
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'calendarEventDetail',
            resolve: {
              calendarEvent: function () {
                return calendarEvent;
              },
              config: function () {
                return {
                  userHasPermission: that.Auth.isAdminSync()
                  || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                }
              }
            }
          });

          modalInstance.result.then(
            function (result) {

              if (result.action === 'removed') {
                that.$timeout(() => {
                  that.getData();
                }, 0);
              }

            },
            function () {
            }
          );

        }
      }
    };

  }

  $onInit() {
    this.CalendarEventService.getUpcoming({count: this.count || 25}, data => {
      data.forEach(evt => {

        var event = evt;

        if (event.isRecurring) {
          event.range = {start: event.start, end: event.recurrence.until};

          event.start = moment(event.start).format("HH:mm");

          if (event.end)
            event.end = moment(event.end).format("HH:mm");

          event.dow = event.recurrence.dayOfWeek;
          event.id = event._id;
        }

        this.eventSources[0].events.push(event);
      });
    }, err => {
      console.log('could not retrieve newest events');
    }) ;
  }
}

export default angular.module('conduuApp.calendarWidget', [])
  .component('calendarWidget', {
    template: `<div id="fullCalendarMain" ui-calendar="$ctrl.uiConfig.calendar" class="span8 calendar" ng-model="$ctrl.eventSources"></div>`,
    bindings: {
     count: '@'
    },
    controller: calendarWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/calendar-widget/calendar-widget.component.js